<div class="card" *ngIf="condizioniCliniche">
    <div class="card-header bg-primary">Condizioni Cliniche</div>
    <div class="card-body">
        <div class="row" *ngIf="condizioniCliniche.length > 0">
            <div class="col-md-12">
                <div *ngFor="let elem of condizioniCliniche; index as i">
                     <i class="far fa-file-alt mr-1"></i> <strong>{{elem.code.coding[0].code}} - {{elem.code.coding[0].display}}</strong> <hr *ngIf="i < condizioniCliniche.length -1">
                </div>
            </div>
        </div>
        <div class="row" *ngIf="condizioniCliniche.length === 0">
            <div class="col-md-12">
                Nessuna patologia inserita.
            </div>
        </div>
    </div>
</div>